// package: concierge_billing_publisher
// file: billing-publisher.proto

var billing_publisher_pb = require("./billing-publisher_pb");
var google_protobuf_empty_pb = require("google-protobuf/google/protobuf/empty_pb");
var common_pb = require("./common_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var BillingPublisherApiService = (function () {
  function BillingPublisherApiService() {}
  BillingPublisherApiService.serviceName = "concierge_billing_publisher.BillingPublisherApiService";
  return BillingPublisherApiService;
}());

BillingPublisherApiService.getBillingDetails = {
  methodName: "getBillingDetails",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: billing_publisher_pb.BillingPublisherResponse
};

BillingPublisherApiService.getInvoices = {
  methodName: "getInvoices",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: true,
  requestType: billing_publisher_pb.PublisherInvoiceRequest,
  responseType: billing_publisher_pb.PublisherInvoiceResponse
};

BillingPublisherApiService.getWithdrawals = {
  methodName: "getWithdrawals",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: true,
  requestType: billing_publisher_pb.PublisherWithdrawalRequest,
  responseType: billing_publisher_pb.PublisherWithdrawalResponse
};

BillingPublisherApiService.createOrUpdatePayoutSettings = {
  methodName: "createOrUpdatePayoutSettings",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_publisher_pb.BillingPublisherPayoutSettings,
  responseType: billing_publisher_pb.BillingPublisherPayoutSettingsResponse
};

BillingPublisherApiService.removePayoutSettings = {
  methodName: "removePayoutSettings",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_publisher_pb.BillingPublisherPayoutRemovingRequest,
  responseType: google_protobuf_empty_pb.Empty
};

BillingPublisherApiService.verifyPayoutValidationCode = {
  methodName: "verifyPayoutValidationCode",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_publisher_pb.BillingPublisherPayoutVerificationRequest,
  responseType: billing_publisher_pb.BillingPublisherPayoutSettingsResponse
};

BillingPublisherApiService.resendPayoutValidationCode = {
  methodName: "resendPayoutValidationCode",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: billing_publisher_pb.BillingPublisherPayoutSettingsResponse
};

BillingPublisherApiService.getPayoutBankAccountRequirements = {
  methodName: "getPayoutBankAccountRequirements",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_publisher_pb.BillingPublisherPayoutRequirementsRequest,
  responseType: billing_publisher_pb.BillingPublisherPayoutRequirementsResponse
};

BillingPublisherApiService.getPayoutBankAccountFeePreview = {
  methodName: "getPayoutBankAccountFeePreview",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_publisher_pb.BillingPublisherPayoutFeePreviewRequest,
  responseType: billing_publisher_pb.BillingPublisherPayoutFeePreviewResponse
};

BillingPublisherApiService.makeWithdrawal = {
  methodName: "makeWithdrawal",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_publisher_pb.BillingPublisherWithdrawalRequest,
  responseType: billing_publisher_pb.BillingPublisherWithdrawalResponse
};

BillingPublisherApiService.updateTaxFormFilledDate = {
  methodName: "updateTaxFormFilledDate",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: google_protobuf_empty_pb.Empty
};

BillingPublisherApiService.getBillingAddress = {
  methodName: "getBillingAddress",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: billing_publisher_pb.BillingPublisherAddress
};

BillingPublisherApiService.updateBillingAddress = {
  methodName: "updateBillingAddress",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: billing_publisher_pb.BillingPublisherAddress,
  responseType: billing_publisher_pb.BillingPublisherAddress
};

BillingPublisherApiService.generateInvoicePdf = {
  methodName: "generateInvoicePdf",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: common_pb.FileResponse
};

BillingPublisherApiService.generateWithdrawalPdf = {
  methodName: "generateWithdrawalPdf",
  service: BillingPublisherApiService,
  requestStream: false,
  responseStream: false,
  requestType: common_pb.IdRequest,
  responseType: common_pb.FileResponse
};

exports.BillingPublisherApiService = BillingPublisherApiService;

function BillingPublisherApiServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

BillingPublisherApiServiceClient.prototype.getBillingDetails = function getBillingDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.getBillingDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.getInvoices = function getInvoices(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(BillingPublisherApiService.getInvoices, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.getWithdrawals = function getWithdrawals(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(BillingPublisherApiService.getWithdrawals, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.createOrUpdatePayoutSettings = function createOrUpdatePayoutSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.createOrUpdatePayoutSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.removePayoutSettings = function removePayoutSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.removePayoutSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.verifyPayoutValidationCode = function verifyPayoutValidationCode(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.verifyPayoutValidationCode, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.resendPayoutValidationCode = function resendPayoutValidationCode(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.resendPayoutValidationCode, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.getPayoutBankAccountRequirements = function getPayoutBankAccountRequirements(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.getPayoutBankAccountRequirements, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.getPayoutBankAccountFeePreview = function getPayoutBankAccountFeePreview(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.getPayoutBankAccountFeePreview, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.makeWithdrawal = function makeWithdrawal(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.makeWithdrawal, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.updateTaxFormFilledDate = function updateTaxFormFilledDate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.updateTaxFormFilledDate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.getBillingAddress = function getBillingAddress(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.getBillingAddress, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.updateBillingAddress = function updateBillingAddress(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.updateBillingAddress, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.generateInvoicePdf = function generateInvoicePdf(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.generateInvoicePdf, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BillingPublisherApiServiceClient.prototype.generateWithdrawalPdf = function generateWithdrawalPdf(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BillingPublisherApiService.generateWithdrawalPdf, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.BillingPublisherApiServiceClient = BillingPublisherApiServiceClient;

